import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLike, pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {pointGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {SplitOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/split-operator/geometry-split-operator-node"
import {
    GeometrySplitOperatorNode,
    splitOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/split-operator/geometry-split-operator-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

export type PointGeometrySplitOperatorParameters = SplitOperatorParameters<PointGeometryAttributeLikeNode, PointGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<PointGeometrySplitOperatorParameters> = {
    nodeClass: "PointGeometrySplitOperator",
    validation: {
        parameters: splitOperatorParametersSchema(pointGeometryAttributeLike, pointGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometrySplitOperator
    extends GeometrySplitOperatorNode<0, PointGeometryAttributeLikeNode, PointGeometryAttributeSetLikeNode>
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
